import React from 'react'
import api from '../irelandApi';


export const getStorePerformances = () => (dispatch) => {
  dispatch({type: "GET_STORE_PERFORMANCE_DATA_PENDING", payload: []});
  return api
    .get('/api/store_performances')
    .then((response) => {
      dispatch({type: "GET_STORE_PERFORMANCE_DATA_FULFILLED", payLoad: response.data.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_STORE_PERFORMANCE_DATA_REJECTED', payLoad: error.response})
    })
};




// WEBPACK FOOTER //
// ./src/actions/store-performance.js